module.exports = __webpack_public_path__ + "static/img/xgs.764c614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xgs.png
// module id = LFGT
// module chunks = 0